import styles from './PersonaList.module.scss';
import PersonaItem from './PersonaItem';

const PersonaList = ({allPersonaList, userId}) => {
  return (
    <ul className={styles.strm_list}>
      {allPersonaList.map((item) => (
        <PersonaItem
          key={item.streamerId}
          personaName={item.streamerNick}
          imageUrl={item.defaultImg}
          personaId={item.streamerId}
          userId={userId}
        />
      ))}
    </ul>
  );
};

export default PersonaList;
